module.exports = __webpack_public_path__ + "b1cfa39d4a1f8c67f0e07c909b1360be.svg";